export const UserPermissions = {
  admin: 'Administrator',
  manageApplications: 'Manage Applications',
  deleteApplications: 'Delete Applications',
  managePermissions: 'Manage Permissions',
  manageResources: 'Manage Resources',
  manageMetadata: 'Manage Metadata',
  createSecrets: 'Create Secrets',
  deleteSecrets: 'Delete Secrets'
} as const;

export type UserPermission = keyof typeof UserPermissions;

export type User = {
  id?: string;
  name: string;
  email: string;
  oauthIds: Record<string, string>;
  permissions: UserPermission[];
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
};
